import { Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationCurveDepedentsCD from '@hook/parametrization/use-curve-depedentscd'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarCurveDepedentsCD from '@component/Parameterization/CurveDepedentsCD/SelectedTableBar'

const ParametrizationCurveDepedentsCD: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    filename,
    pagination,
    filters,
    fetching,
    query,
    tableInteraction,
    actions,
    getData,
    getCenters,
    setFilename,
    setQuery
  } = useParametrizationCurveDepedentsCD()

  const { hasSessions } = useSessions()
  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    data?.length === 0 && getData()
    getFilters({})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box>
      <LayoutTools
        title={filename}
        filters={filters}
        actions={actions}
        query={query}
        onSearchChange={setQuery}
        onTitleChange={setFilename}
        isDisabled={loading || fetching || data.length === 0}
      />
      {loading ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : data.length === 0 ? (
        <LayoutEmpty
          title="Nada encontrado!"
          message="Filtre sua busca ao lado para obter informações"
        />
      ) : (
        <Box>
          <SelectedTableBarCurveDepedentsCD />

          <Box paddingLeft={2}>
            <GridQuantity data={data} />
          </Box>

          <TableGrid
            id="purschase-table"
            headers={headers}
            query={query}
            data={data}
            itsSortable={true}
            loading={fetching}
            actions={tableInteraction}
            height={tableHeight}
            pagination={pagination}
          />
        </Box>
      )}
    </Box>
  )
}

export default ParametrizationCurveDepedentsCD
